var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "app-component" },
    [
      _c("tc-header", {
        attrs: { page: _vm.page, access_token: _vm.access_token }
      }),
      _vm._v(" "),
      _c("tc-title", { attrs: { title: _vm.title, back_page: _vm.back_page } }),
      _vm._v(" "),
      _c(
        "main",
        [
          _vm.page == "welcome"
            ? _c("TcWelcome")
            : _vm.page == "login-dni"
            ? _c("TcLoginDni")
            : _vm.page == "login-public"
            ? _c("TcLoginPublic")
            : _vm.page == "login"
            ? _c("TcLogin")
            : _vm.access_token && _vm.page == "home"
            ? _c("TcHome")
            : _vm.access_token && _vm.page == "new-appointment"
            ? _c("TcNewAppointment")
            : _vm.access_token && _vm.page == "my-appointments"
            ? _c("TcMyAppointments")
            : _vm.access_token && _vm.page == "calendar"
            ? _c("TcCalendar")
            : _vm.access_token && _vm.page == "events-list"
            ? _c("TcEventsList")
            : _vm.access_token && _vm.page == "events-my-calendar"
            ? _c("TcEventsMyCalendar")
            : _vm.access_token &&
              _vm.page == "inscription" &&
              _vm.$root.selected_event
            ? _c("TcEventInscription", {
                attrs: { event: _vm.$root.selected_event }
              })
            : _vm.page == "test"
            ? _c("TcTest")
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }